import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TextFieldData from "../../GeneralDisclosure/TextFiledData";
import AddIcon from "@mui/icons-material/Add";
import {
  Box,
  TableContainer,
  Paper,
  Typography,
  TextField,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  MenuItem,
  Select,
  IconButton,
  FormHelperText,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EastIcon from "@mui/icons-material/East";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";

import styles from "../../../../styles/gri/general.module.css";

const TableBox = ({
  title,
  formData,
  setFormData,
  errors,
  setErrors,
  inputData,
  handleAdd,
  unitsAll,
  disabled1,
  defaultSegments,
  disabled,
  hide
}) => {
  console.log(inputData, "inputData");
  const handleChange = (e, type) => {
    const { name, value } = e.target;
    console.log(name, value, type, "handleChangeTable");
    const [main, sub, field] = name.split(".");

    if (type === "number" && !/^\d*\.?\d*$/.test(value)) return;

    setFormData((prev) => {
      if (sub) {
        return {
          ...prev,
          [main]: {
            ...prev[main],
            [sub]: {
              ...prev[main][sub],
              [field]: value,
            },
          },
        };
      } else {
        return { ...prev, [name]: value };
      }
    });
  };
  useEffect(() => {}, [unitsAll]);

  const handleChangeNumber = (e) => {
    const { name, value } = e.target;

    console.log(name, value, "handleChangeTable Number");
    if (!/^\d*$/.test(value)) return;

    console.log(name, value, "handleChangeTable Number 777");

    setFormData((prev) => {
      const [main, sub, field] = name.split(".");
      if (sub) {
        return {
          ...prev,
          [main]: {
            ...prev[main],
            [sub]: {
              ...prev[main][sub],
              [field]: value,
            },
          },
        };
      } else {
        return { ...prev, [name]: value };
      }
    });
  };

  const handleChangeRadio = (e) => {
    const { name, value } = e.target;
    console.log(name, value, "handleChangeTable");
    const [main, sub, field] = name.split(".");
    setFormData((prev) => {
      if (sub) {
        return {
          ...prev,
          [main]: {
            ...prev[main],
            [sub]: {
              ...prev[main][sub],
              [field]: value,
            },
          },
        };
      } else {
        return { ...prev, [name]: value };
      }
    });
  };

  return (
    <>
      <p className={styles.ques_heading} style={{ textIndent: "-1rem",paddingLeft: "1rem", marginBottom: hide ? "-2rem" : "0"}}>{title}</p>
      {inputData?.map((section, tableIndex) => (
        <TableContainer
          key={tableIndex}
          component={Paper}
          sx={{
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            mt: "1rem",
            width: "98%",
            ml: 2,
            borderRadius: "10px",
          }}
        >
          <Table sx={{ border: "1px solid #ddd", borderRadius: "10px" }}>
            <TableHead>
              <TableRow
                sx={{
                  borderRadius: "10px",
                  backgroundColor: "#1C486B",
                  border: "1px solid #ddd",
                }}
              >
                <TableCell
                  sx={{
                    border: "1px solid #ddd",
                    fontWeight: "bold",
                    color: "#FFFFFF",
                    width: "10rem",
                  }}
                >
                  {"S. No."}
                </TableCell>
                <TableCell
                  sx={{
                    border: "1px solid #ddd",
                    fontWeight: "bold",
                    color: "#FFFFFF",
                    width: "40rem",
                  }}
                >
                  {section?.defalut}
                </TableCell>
                {section?.fields?.map((field, index) => (
                  <TableCell
                    key={index}
                    sx={{
                      border: "1px solid #ddd",
                      fontWeight: "bold",
                      color: "#FFFFFF",
                      width: "40rem",
                    }}
                  >
                    {field?.title}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {defaultSegments?.map((segment, rowIndex) => (
                <TableRow key={rowIndex}>
                  {/* Handle SNo. properly for Total row */}
                  <TableCell sx={{textAlign:"center",width:"5%"}}>{segment?.romanIndex ? segment?.romanIndex : rowIndex + 1}.</TableCell>
                  <TableCell
                    sx={{
                      border: "1px solid #DBDBDB",
                      py: "0.5rem",
                      width: section?.colwidth ? section?.colwidth : "63%",
                      maxWidth: "100%",
                    }}
                  >
                    {segment?.title}
                  </TableCell>

                  {section?.fields?.map((field, index) => {
                    // {
                    //   console.log(
                    //     "fieldsData",
                    //     field?.type,
                    //     field?.field,
                    //     segment?.type === "number" &&
                    //       (field?.field === "value" ||
                    //         field?.field === "amount")
                    //   );
                    // }
                    return (
                      <TableCell
                        key={index}
                        sx={{
                          border: "1px solid #DBDBDB",
                          py: "0.5rem",
                          width: section?.colwidth ? section?.colwidth : "63%",
                          maxWidth: "100%",
                          background: "white",
                        }}
                      >
                        {console.log(
                          unitsAll,
                          section?.filedName,
                          segment?.fieldName,
                          field.field,
                          formData,
                          formData?.[section?.filedName]?.[
                            segment?.fieldName
                          ]?.[field?.field],
                          "unitsAll"
                        )}
                        <Box sx={{ minWidth: "100px" }}>
                          {field?.type === "select" ? (
                            <Select
                              sx={{
                                height: "2rem",
                                border: "none",
                                boxShadow: "none", // Ensures no shadow appears
                                "& .MuiOutlinedInput-notchedOutline": {
                                  border: "none", // Removes default MUI border
                                },
                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                  border: "none", // Ensures no border on hover
                                },
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                  {
                                    border: "none", // Removes border on focus
                                  },
                              }}
                              name={
                                section?.filedName
                                  ? `${section?.filedName}.${segment?.fieldName}.${field.field}`
                                  : segment?.fieldName
                              }
                              value={
                                // section?.filedName
                                //   ? formData?.[section?.filedName]?.[
                                //       segment?.fieldName
                                //     ]?.[field.field]
                                //   : formData?.[segment?.fieldName] ||
                                unitsAll || ""
                              }
                              onChange={(e) => handleChangeRadio(e)}
                              disabled={disabled1 ? disabled1 : false}
                              displayEmpty
                              size="small"
                              fullWidth
                              // disabled={!data?.[DropDownData?.fieldName]?.[list?.fields]?.active}
                            >
                              <MenuItem value="" disabled1>
                                <em>Select</em>
                              </MenuItem>
                              {console.log(segment?.list, "segment?.list")}
                              {segment?.list?.map((data, index) => (
                                <MenuItem key={index} value={data}>
                                  {data}
                                </MenuItem>
                                // console.log(data,"segment?.list")
                              ))}
                            </Select>
                          ) : (
                            <TextField
                              sx={{ width: "100%" }}
                              name={
                                section?.filedName
                                  ? `${section?.filedName}.${segment?.fieldName}.${field.field}`
                                  : `${segment?.fieldName}` || ""
                              }
                              // value={(section?.filedName) ?
                              //   (formData?.[section?.filedName]?.[segment?.fieldName]?.[field.field]):
                              //   (formData?.[segment?.fieldName]) ||""
                              // }
                              value={
                                section?.filedName
                                  ? formData?.[section?.filedName]?.[
                                      segment?.fieldName
                                    ]?.[field?.field] ?? ""
                                  : formData?.[segment?.fieldName] ?? ""
                              }
                              placeholder={
                               ( field?.type==="number"||
                                segment?.type==="number"
                               ) ? "Enter Number" :"Enter Text"
                              }
                              type="text"
                              multiline
                              rows={1}
                              size="small"
                              variant={
                                segment?.type === "number" &&
                                (field?.field === "value" ||
                                  field?.field === "amount")
                                  ? "standard"
                                  : "standard"
                              }
                              pattern={
                                segment?.type === "number" &&
                                (field?.field === "value" ||
                                  field?.field === "amount")
                                  ? "[0-9]*"
                                  : undefined
                              }
                              InputProps={{ disableUnderline: true }}
                              // disabled={segment?.title === "Total"} // Prevent editing "Total" row
                              // onChange={(e) =>
                              //   segment?.type === "number" && (field?.field==="value" || field?.field==="amount")
                              //     ? handleChangeNumber(e)
                              //     : handleChange(e)
                              // }

                              onChange={(e) =>
                                handleChange(
                                  e,
                                  field?.type ? field?.type :
                                  segment?.type ?  segment?.type :
                                   "text"
                                )
                              }
                              // onChange={(e) => {
                              //   const inputValue = e.target.value;

                              //   // If segment type is "number" and field is "value" or "amount", use handleChangeNumber
                              //   if (segment?.type === "number" && (field?.field === "value" || field?.field === "amount")) {
                              //     if (!/^\d*$/.test(inputValue)) {
                              //       console.log("fieldsValues",field?.field,segment?.type)
                              //       handleChangeNumber(e);
                              //     }
                              //   } else {
                              //     console.log("fieldsValues not number",field?.field,segment?.type)
                              //     handleChange(e);
                              //   }
                              // }}
                              disabled={disabled}
                            />
                          )}
                        </Box>
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ))}

      {/* Add Row Button */}
    </>
  );
};
export default TableBox;
